import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import NewBodyMap from "./NewBodyMap";
import LoadingSpinner from "../../../../partials/loading";
import { LIST, CREATE } from "../../../../queries/body-map.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import BodyMapList from "./BodyMapList";
import auth from "../../../../providers/Auth.Provider";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

function BodyMap({ location }) {
    const [newItem, setNewItem] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [single, setSingle] = useState(null);
    const title = "Patient Body Map";
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { id } = GetToken() && GetAuthenticatedStaff();
    const patient = ReadData();

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    // query
    const { loading, data } = useQuery(LIST, {
        variables: {
            patient: patient.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // New
    const [PostCreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { NewBodyMap } }) {
            const { GetPatientBodyMap } = caches.readQuery({
                query: LIST,
                variables: {
                    patient: patient.id,
                },
            });
            GetPatientBodyMap.docs.unshift(NewBodyMap.doc);
            caches.writeQuery({
                query: LIST,
                variables: {
                    patient: patient.id,
                },
                data: {
                    GetPatientBodyMap,
                },
            });
        },
        onCompleted: (d) => {
            const { doc, message } = d.NewBodyMap;
            setNewItem(false);
            setActiveItem(null);
            setSingle(doc);
            scrollTop();
            toast.success(message);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                {!newItem && !activeItem && !single && (
                    <div className="col-md-12 col-sx-12 fade-in">
                        <div className="card m-t-20">
                            <div className="card-head">
                                <header>Patient Body Map</header>
                                <div className="float-right mt-2 mr-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            scrollTop();
                                            setNewItem(true);
                                            setActiveItem(null);
                                            setSingle(null);
                                        }}
                                        data-toggle="tab"
                                        className="mdl-button fade-in mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle"
                                    >
                                        <i className="material-icons text-primary"> add</i> New Body Map
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-t-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />

                                {!loading && (
                                    <BodyMapList
                                        onView={(item) => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            setSingle(item);
                                        }}
                                        items={data && data.GetPatientBodyMap.docs}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {newItem && !activeItem && !single && (
                    <div className="col-md-12 col-xs-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            setSingle(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New Patient Body Map
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <NewBodyMap
                                    id={id}
                                    onSubmit={async (item) => {
                                        await PostCreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    patient: patient.id,
                                                },
                                            },
                                        });
                                    }}
                                />
                                <LoadingSpinner loading={cLoading} />
                            </div>
                        </div>
                    </div>
                )}
                {!newItem && single && !activeItem && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            setSingle(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Patient body map detail
                                </header>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-6 col-lg-4">
                                        <h5>Injury Type</h5>
                                        <p>{single.injuryType}</p>
                                    </div>
                                    <div className="col-6 col-lg-4">
                                        <h5>Description</h5>
                                        <p>{single.description}</p>
                                    </div>
                                    <div className="col-112 col-lg-10">
                                        <img className="no-scale" src={single.photo} alt={single.injuryType} srcset={single.photo} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default BodyMap;
